import React from 'react';
import {Box, Typography} from '@material-ui/core';
import PanelChangeAdUnitLink from './PanelChangeAdUnitLink';

const PanelChangeAdUnitList = ({classes, adUnits = [], isTagLevel = false, onSelectAdUnit}) => {
  const units = adUnits.filter(unit => unit?.adunitId != null);
  if (units.length === 0) return null;

  return (
    <Box className={classes.scopeExpandedList}>
      {isTagLevel ? (
        <Typography variant="caption" className={classes.scopeExpandedHint}>
          Tag-level change
        </Typography>
      ) : null}
      {units.map(unit => (
        <Box key={unit.adunitId} className={classes.groupHeader}>
          <PanelChangeAdUnitLink
            classes={classes}
            unit={unit}
            onOpen={() => onSelectAdUnit?.(unit)}
          />
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(PanelChangeAdUnitList);
